import {
  Button,
  Drawer,
  Modal,
  TagPicker,
  SelectPicker,
  Tag,
  DatePicker,
  Uploader
} from "rsuite";
import CameraRetroIcon from '@rsuite/icons/legacy/CameraRetro';
import consts from "../../consts";
import moment from "moment";
import { Icon } from "@rsuite/icons";
import { useEffect } from "react";
import "rsuite/dist/rsuite.min.css";
import Table from "../../components/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  allServicos,
  updateServico,
  filterServicos,
  addServico,
  removeServico,
  removeArquivos,
  resetServico,
} from "../../store/modules/servico/actions";

const Servicos = () => {
  const dispatch = useDispatch();
  const { servicos, behavior, form, components, servico } = useSelector(
    (state) => state.servico
  );

  const setComponent = (component, state) => {
    dispatch(
      updateServico({
        components: { ...components, [component]: state },
      })
    );
  };

  const setServico = (key, value) => {
    console.log(value, key);
    dispatch(
      updateServico({
        servico: { ...servico, [key]: value },
      })
    );
  };

  const save = () => {
    dispatch(addServico());
  };
  const remove = () => {
    dispatch(removeServico());
  };
  useEffect(() => {
    dispatch(allServicos());
  }, []);

  return (
    <div className="col p-5 h-100 overflow-auto">
      <Drawer
        open={components.drawer}
        size="sm"
        onClose={() => setComponent("drawer", false)}
      >
        <Drawer.Body>
          <h3>{behavior === "create" ? "Criar Novo" : "Atualizar"} servico </h3>

          <div className="row mt-3">
            <div className="form-group col-6">
              <b>Titulo</b>

              <input
                type="text"
                className="form-control"
                placeholder="Titulo do serviço"
                value={servico.titulo}
                onChange={(e) => {
                  setServico("titulo", e.target.value);
                }}
              />
            </div>
            <div className="form-group col-6">
              <b>Preço</b>

              <input
                type="text"
                className="form-control"
                placeholder="Preço do serviço"
                value={servico.preco}
                onChange={(e) => {
                  setServico("preco", e.target.value);
                }}
              />
            </div>
            <div className="form-group col-6">
              <b>Recorrencia</b>

              <input
                type="text"
                className="form-control"
                placeholder="Recorrencia do serviço"
                value={servico.recorrencia}
                onChange={(e) => {
                  setServico("recorrencia", e.target.value);
                }}
              />
            </div>
            <div className="form-group col-6">
              <b>Comissao</b>

              <input
                type="text"
                className="form-control"
                placeholder="Comissao do serviço"
                value={servico.comissao}
                onChange={(e) => {
                  setServico("comissao", e.target.value);
                }}
              />
            </div>
            <div className="form-group col-6">
              <b>Duração</b>

              <DatePicker
                block
                format="HH:mm"
                hideMinutes={(min) => ![0, 30].includes(min)}
                value={new Date(`${servico.duracao}`)}
                onChange={(e) => {
                  setServico("duracao", e);
                }}
              />
            </div>

            <div className="form-group col-6 ">
              <b className="">Status</b>
              <select
                className="form-control"
                placeholder="status do servico"
                appearance="primary"
                value={servico.status}
                onChange={(e) => {
                  setServico("status", e.target.value);
                }}
              >
                <option value="A">Ativo</option>
                <option value="I">Inativo</option>
              </select>
            </div>

            <div className="form-group col-12">
              <b>Descrição</b>

              <textarea
                rows="5"
                type="text"
                className="form-control"
                placeholder="Descrição do serviço"
                value={servico.descricao}
                onChange={(e) => {
                  setServico("descricao", e.target.value);
                }}
              ></textarea>
            </div>

            <div className="form-group col-12">
              <b className="d-block"> Imagem de servico</b>
              <Uploader
                multiple
                autoUpload={false}
                listType="picture"
                defaultFileList={servico.arquivos.map((servico, index)=>({
                  name:servico?.caminho,
                  fileKEy: index,
                  url:`${consts.bucketURL}/${servico?.caminho}`
                }))}
                action="//jsonplaceholder.typicode.com/posts/"
                onChange={(files)=>{
                  const arquivos = files.filter((f)=> f.blobFile).map((f)=> f.blobFile)

                  setServico("arquivos", arquivos)
                }}

                onRemove={(file)=>{
                  if(behavior === "update" && file.url){
                    dispatch(removeArquivos(file.name))
                  }
                }
              
                
                }
              >
                <button>
                  <CameraRetroIcon size="lg" />
                </button>
              </Uploader>
            </div>
          </div>
          <Button
            loading={form.saving}
            className=" mt-3"
            appearance="primary"
            color={behavior === "create" ? "green" : "blue"}
            size="lg"
            block
            onClick={() => {save();
            }}
          >
          {behavior === "create" ? "Salvar" : "Atualizar"} Serviço
          </Button>
          {behavior==="update" && (
                 <Button
                 loading={form.saving}
                 className=" mt-3"
                 color= "red"
                 appearance="primary"
                 size="lg"
                 block
                 onClick={() => {
                  setComponent('confirmDelete', true)
                 }}
               >
                Elimnar Serviços
               </Button>
          )}

        </Drawer.Body>
      </Drawer>

      <Modal
        open={components.confirmDelete}
        onHide={() => setComponent("confirmDelete", false)}
        size="xs"
      >
        <Modal.Body>
          <Icon
            icon="remind"
            style={{
              color: '#ffb300',
              fontSize: 24,
            }}
          />
          {"   "}Tem certeza que deseja excluir? Essa ação será inrreversivel!
        </Modal.Body>
        <Modal.Footer>
          <Button  appearance="primary" loading={form.saving} onClick={() => remove()} color="red">
            Sim, tenho certeza!
          </Button>
          <Button
            
            onClick={() => setComponent("confirmDelete", false)}
            appearance="subtle"
          >
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="row">
        <div className="col-6">
          <div className="w-100 d-flex justify-content-between">
            <h2 className="mb-4 mt-0">Serviços</h2>
            <div>
              <button
                className="btn btn-primary btn-sm   "
                onClick={() => {
                  dispatch(resetServico())
                  dispatch(

                    updateServico({
                      behavior: "create",
                    })
                  );
                  setComponent("drawer", true);
                }}
              >
                <span className="mdi mdi-plus"> Novo servico</span>
              </button>
            </div>
          </div>
          <Table
            loading={form.filtering}
            data={servicos}
            config={[
              {
                label: "titulo",
                key: "titulo",

                width: 200,
              },
              {
                label: "R$ preço",

                width: 200,
                content: (servico) =>
                  `R$ ${parseInt(servico.preco).toFixed(2)}`,
              },
              {
                label: "% Comissão",
                content: (servico) => `${servico.comissao}%`,
                width: 200,
              },
              {
                label: "duracao",
                content: (servico) => moment(servico.duracao).format("HH:mm"),
                width: 200,
              },
              {
                label: "Recorrencia",
                content: (servico) => `${servico.recorrencia} dias`,
                width: 200,
              },
              {
                label: "status",
                width: 200,
                content: (servico) => (
                  <Tag color={servico.status === "A" ? "green" : "red"}>
                    {servico.status === "A" ? "Ativo" : "Inativo"}
                  </Tag>
                ),
              },
            ]}
            actions={(servico) => (
              <Button color="blue" appearance="primary" size="xs">
                Ver informções
              </Button>
            )}
            onRowClick={(servico) => {
              dispatch(
                updateServico({
                  behavior: "update",
                })
              );
              setComponent("drawer", true);

              dispatch(updateServico({ servico }));
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Servicos;
